//------------ IMPORTAÇÕES ------------//
import { X } from "lucide-react";
import { useContext } from "react";
import { LeadsContext } from "../../context/LeadsContext";
import { createLeadService, loadLeadsService } from "../../services";



//------------ EXPORTAÇÃO DO MODAL CREATE LEAD ------------//
export default function ModalCreateLead() {



  //------------ CRIAÇÃO DE HOOKS ------------//
  const { isOpenModalCreateLead, setIsOpenModalCreateLead } = useContext(LeadsContext);
  const { newLead, setNewLead } = useContext(LeadsContext);
  const { leads, setLeads } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { filterStatus, setFilterStatus } = useContext(LeadsContext);
  const { filterTag, setFilterTag } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
  // Responsável por atualizar as leads via API
  // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
  // Armazena as leads no Estado "leads"
  // Armazena o total no Estado "total"
  async function handleRefreshLeads() {
    const offset = (currentPage - 1) * itemsPerPage;
    const term = "";
    const response = await loadLeadsService(itemsPerPage, offset, term, filterStatus, filterTag, integrationsFilter);
    if (response) {
      setLeads(response.data.leads);
      setTotal(response.data.total);
    }
  };



  //------------- FUNÇÃO ASSÍNCRONA SALVAR NOVO LEAD ----------//
  const handleCreateLead = async () => {
    const response = await createLeadService(newLead);
    if (response) {
      setIsOpenModalCreateLead(false);
      setNewLead({ nome: "", email: "", telefone: "" });
      handleRefreshLeads();
    }
  };



  //--------------- RETORNO CONDICIONAL DO MODAL CREATE LEAD ---------------//
  return (
    <>
      {!isOpenModalCreateLead
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Adicionar Lead</h2>
                <button onClick={() => setIsOpenModalCreateLead(false)}><X className="text-white" /></button>
              </div>
              <div className="flex flex-col gap-3">
                <input
                  type="text"
                  placeholder="Nome"
                  value={newLead.nome}
                  onChange={(e) => setNewLead({ ...newLead, nome: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={newLead.email}
                  onChange={(e) => setNewLead({ ...newLead, email: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <input
                  type="text"
                  placeholder="Telefone"
                  value={newLead.telefone}
                  onChange={(e) => setNewLead({ ...newLead, telefone: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <div className="flex justify-end gap-3">
                  <button onClick={() => setIsOpenModalCreateLead(false)} className="px-4 py-2 bg-surface-3 rounded">Cancelar</button>
                  <button onClick={handleCreateLead} className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
